/** Granular admin sidebar page tab names (super-admin page visibility). */

const LEGACY_ADMIN_TAB = 'admin';

const ALL_ADMIN_TAB_NAMES = [
  'adminManualOverride',
  'adminParaplannerOverride',
  'adminPageVisibility',
  'adminDefaultFilters',
  'adminTeams',
  'adminSmsNumbers',
  'adminIdUploadSms',
  'adminSmsScheduling',
  'adminDocusignSettings',
  'adminFormConfig',
  'adminPortfolios',
  'adminAiPrompts',
  'adminSystemEmails',
  'adminCorrespondence',
  'adminBanner',
  'adminMarketingImports',
  'adminClientJson',
  'adminDocxTemplates',
  'adminDocumentLayout',
  'adminDeployments',
  'adminDocumentQa',
  'adminArDocumentTest',
  'adminChartSettings',
  'adminDocumentStyling',
  'adminContentBlocks',
  'adminDocuments',
  'adminWorkflows',
  'adminAssumptions',
  'adminClientAllocation',
  'adminGuidedSandbox',
  'adminSettingsInCode',
];

/**
 * Admin → Documents replaced five pages (Sept 2026). The old ids stay valid as
 * aliases: a stored Page Visibility list granting any of them grants Documents,
 * and granting Documents grants every old id (server routes still gate on them).
 */
const DOCUMENTS_PAGE_ID = 'adminDocuments';
const DOCUMENTS_PAGE_ALIASES = [
  'adminDocumentLayout',
  'adminContentBlocks',
  'adminDocumentStyling',
  'adminChartSettings',
  'adminDocxTemplates',
];

/** Default landing tab for super admins when legacy `admin` is configured. */
const DEFAULT_SUPER_ADMIN_ADMIN_TAB = 'adminTeams';

/**
 * Expand legacy single `admin` page id to all granular admin tabs.
 * @param {string[]} pages
 * @returns {string[]}
 */
function normalizeAdminPageIds(pages) {
  if (!Array.isArray(pages)) return [];
  const out = new Set(pages.filter((id) => id && id !== LEGACY_ADMIN_TAB));
  if (pages.includes(LEGACY_ADMIN_TAB)) {
    ALL_ADMIN_TAB_NAMES.forEach((id) => out.add(id));
  }
  if (out.has(DOCUMENTS_PAGE_ID) || DOCUMENTS_PAGE_ALIASES.some((id) => out.has(id))) {
    out.add(DOCUMENTS_PAGE_ID);
    DOCUMENTS_PAGE_ALIASES.forEach((id) => out.add(id));
  }
  return Array.from(out);
}

function isAdminTab(tabName) {
  return tabName === LEGACY_ADMIN_TAB || ALL_ADMIN_TAB_NAMES.includes(tabName);
}

function getFirstAccessibleAdminTab(accessibleTabs) {
  const set = new Set(accessibleTabs || []);
  if (set.has(LEGACY_ADMIN_TAB)) {
    return DEFAULT_SUPER_ADMIN_ADMIN_TAB;
  }
  return ALL_ADMIN_TAB_NAMES.find((tab) => set.has(tab)) || null;
}

module.exports = {
  LEGACY_ADMIN_TAB,
  DOCUMENTS_PAGE_ID,
  DOCUMENTS_PAGE_ALIASES,
  ALL_ADMIN_TAB_NAMES,
  DEFAULT_SUPER_ADMIN_ADMIN_TAB,
  normalizeAdminPageIds,
  isAdminTab,
  getFirstAccessibleAdminTab,
};
